import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.TEMP_PONS_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/TempPONS/List/TempPONSList.svelte"),
            title: "Temporary Plans of Nursing Services"
        }
    ]
};

export default routerConfig;

